<div class="loader-wrapper">
    <div class="snippet" data-title="dot-bricks">
        <div class="stage">
            <div class="dot-bricks"></div>
        </div>
    </div>
</div>
